enum RoleEnum {
    ROLE_USER = 'ROLE_USER',
    ROLE_DOCTOR = 'ROLE_DOCTOR',
    ROLE_DOCTOR_GLOBAL = 'ROLE_DOCTOR_GLOBAL',
    ROLE_ADMINISTRATOR_OFFICE = 'ROLE_ADMINISTRATOR_OFFICE',
    ROLE_ADMIN_ERGO = 'ROLE_ADMIN_ERGO',
}

export default RoleEnum;
